
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */


.visually-hidden {

    position: absolute;

    width: 1px;

    height: 1px;

    padding: 0;

    margin: -1px;

    overflow: hidden;

    clip: rect(0, 0, 0, 0);

    white-space: nowrap;

    border-width: 0
}

li {

    list-style-type: none
}

.pager__items {

    display: flex;

    justify-content: center;

    padding-left: 0px
}

.pager__item {

    display: none
}

@media (min-width: 768px) {

    .pager__item {

        display: inline-block
    }
}

.pager__item.is-active {

    display: inline-block
}

.pager__item--next, .pager__item--previous {

    display: inline-block
}

.pager__item--last, .pager__item--first {

    display: none
}

@media (min-width: 1024px) {

    .pager__item--last, .pager__item--first {

        display: inline-block
    }
}

idb-button {

    margin-left: 0.25rem;

    margin-right: 0.25rem
}
`;